export default __webpack_public_path__ + "static/media/wide_button_presssed_badge.be856a75.png";